import { usePatchTask, type TaskDto } from '../../api/tasks';
import { DatePicker } from '../DatePicker';

export function ScheduledEditor({ task, onClose }: { task: TaskDto; onClose: () => void }) {
  const patch = usePatchTask();
  return (
    <DatePicker
      label="Scheduled"
      value={task.scheduledAt}
      onPick={(iso) => {
        patch.mutate({ id: task.id, patch: { scheduledAt: iso } });
        onClose();
      }}
    />
  );
}
